'use strict'

angular
  .module('basalteApp')
  .constant('BAS_VOLUME', {
    DEFAULT_VOLUME: 75,
    EVT_VOLUME_CHANGED: 'evtVolumeChanged'
  })
